import { EPatientRelationship, IMember } from '@/types';
import { differenceInYears } from 'date-fns';
import capitalize from 'lodash.capitalize';
import {
  AvatarDaughter,
  AvatarFather,
  AvatarFemale,
  AvatarMale,
  AvatarMother,
  AvatarSon,
} from 'ui/icons';

const getPatientAge = (patient: Partial<IMember>) => {
  const { dob } = patient;
  if (dob) {
    const age = differenceInYears(new Date(), new Date(dob));
    if (Number.isNaN(age) || !dob) {
      return null;
    }
    return age;
  }
  return null;
};

const getPatientFullName = (patient: Partial<IMember>) => {
  const { firstName, lastName } = patient;
  return `${firstName ?? ''} ${lastName ?? ''}`.trim();
};

const getPatientIcon = (patient: Partial<IMember>) => {
  const { gender, relationship } = patient;
  if (
    relationship === EPatientRelationship.SELF ||
    relationship === EPatientRelationship.SPOUSE ||
    relationship === EPatientRelationship.SIBLING
  ) {
    if (gender === 'female') {
      return AvatarFemale;
    }
    return AvatarMale;
  }

  if (relationship === EPatientRelationship.KID) {
    if (gender === 'female') {
      return AvatarDaughter;
    }
    return AvatarSon;
  }

  if (
    relationship === EPatientRelationship.PARENT ||
    relationship === EPatientRelationship.PARENT_IN_LAW ||
    relationship === EPatientRelationship.PARENT_IN_LAW_OTHER
  ) {
    if (gender === 'female') {
      return AvatarMother;
    }
    return AvatarFather;
  }
};

const getPatientDetails = (patient: Partial<IMember>) => {
  const { relationship, dependentId, memberId } = patient;
  const isDependent = dependentId != null;

  return {
    age: getPatientAge(patient),
    fullName: getPatientFullName(patient),
    icon: getPatientIcon(patient),
    relationship: capitalize(relationship),
    isDependent,
    id: isDependent ? dependentId : memberId,
  };
};

export default getPatientDetails;
